import * as types from '@/store/mutationTypes';
import API from '@/api';

const state = {
  results: [],
  userLocation: null,
};

const getters = {
  locations: mapState => mapState.results,
  userLocation: mapsState => mapsState.userLocation,
};

const mutations = {
  [types.SET_MAP_RESULTS](mapsState, results) {
    // eslint-disable-next-line no-param-reassign
    mapsState.results = results || [];
  },
  [types.SET_USER_POSITION](mapsState, geoLocation) {
    // eslint-disable-next-line no-param-reassign
    mapsState.userLocation = geoLocation;
  },
  [types.CLEAR_MAPS_MODULE](mapsState) {
    // eslint-disable-next-line no-param-reassign
    mapsState.locations = [];
    // eslint-disable-next-line no-param-reassign
    mapsState.userLocation = null;
  },
};

const actions = {
  clear({ commit }) {
    commit(types.CLEAR_MAPS_MODULE);
  },
  async searchLocation({ commit }, filters) {
    const response = await API.map.search(filters);
    commit(types.SET_MAP_RESULTS, response);
  },
  async getUserPosition({ commit }) {
    const response = await API.map.getUserPosition();
    commit(types.SET_USER_POSITION, response);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/maps.js